var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


var ProductView = Backbone.View.extend({

	events: {
		//'click .button-booking': 'handleBooking',
	},

	initialize: function() {
		this.listenTo(this.model, "change", this.render);
	},

	render: function() {
		this.el.innerHTML = TemplateCache.render('products-template', this.model.toJSON());
	},

	handleBooking: function(e) {
		e.preventDefault();

		var data = window.miniEngine.app.formModel.getForm();
		data['class'] = $(e.target).data('class');

		TraminoWarenkorb.add(data).then(function() {
			// Irgendwo hin scrollen, irgendwas anzeigen...
			
		});
	},

});

module.exports = ProductView;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/miniengine/views/ProductsView.js
 **/